<template>
  <div class="d-timetal__container">
    <div class="d-guides">
      <StilGuides :video-id="'5Id4TeuHMvI'"
                  textForLink="Guide: Se videoguide for kompetenceindberetning i Docendo">
      </StilGuides>
      <div class="text-explainer">
        <a href="https://statistik.uni-c.dk/linjefag/Dokumentation/Generelvejledning2025.pdf" target="_blank">
          Link til STIL's egen vejledning</a>
        <p><b>Linjefag (L):</b> At have undervisningskompetence i et fag betyder, at underviseren har haft det
          pågældende fag som linjefag på læreruddannelsen eller som ekstra linjefag på et senere tidspunkt.</p>
        <p><b>Tilsvarende kompetence (K):</b> At have kompetence svarende til undervisningskompetence betyder, at
          underviseren for eksempel har en efteruddannelse, videreuddannelse, kompetencegivende uddannelse eller et
          længerevarende kursusforløb, der vurderes at give kompetence svarende til undervisningskompetence.</p>
        <p>Skolens leder må foretage et skøn i denne forbindelse. En underviser kan samlet set maks. have
          kompetencer (undervisningskompetence og tilsvarende
          kompetence) i seks fag</p>
        <p><b>Ikke indberet person:</b> Personale der ikke skal indberettes sættes til stillingen "Ingen
          undervisningsopgaver (ikke indberet)"</p>
      </div>
    </div>
    <div class="d-filters">
      <div class="d-filters__filter" :class="{'d-filters__filter--active': activeUserFilter === 0}"
           @click="activeUserFilter = 0">Indberettes
        <div class="d-pill">{{ filledUsers.length }}</div>
      </div>
      <div class="d-filters__filter" :class="{'d-filters__filter--active': activeUserFilter === 1}"
           @click="activeUserFilter = 1">Indberettes ikke
        <div class="d-pill">{{ unfilledUsers.length }}</div>
      </div>
    </div>
    <table class="d-table">
      <thead>
      <tr>
        <th @click="setSortProperty('name')" class="d-table__sorter d-table__name" :class="{'d-table__sorter--active': sortProperty === 'name'}">Navn <span class="icon-menu-open"></span> </th>
        <th @click="setSortProperty('v_stil_stilling')" class="d-table__sorter" :class="{'d-table__sorter--active': sortProperty === 'v_stil_stilling'}">Stilling <span class="icon-menu-open"></span> </th>
        <th>CPR</th>
        <th>Kompetencer: (L: Linjefag, K: Tilsvarende kompetencer)</th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="filteredUsersWithVProps.length < 1">
        <td colspan="4">
          <p class="text-explainer">Ingen skal ikke indberetes</p>
        </td>
      </tr>
      <tr v-for="(user, userIdx) in sortedUsers" :key="user.id">
        <td>{{ user.name }}</td>
        <td>
          <select class="timetal-select" v-model="user.v_stil_stilling"
                  @change="updateUser(user, 'stil_stilling', $event.target.value)">
            <option value="LA">Lærer</option>
            <option value="BH">Børnehaveklasseleder</option>
            <option value="PA">Pædagog</option>
            <option value="LE">Leder</option>
            <option value="AN">Andre med undervisningsopgaver</option>
            <option value="KO">Konsulenter</option>
            <option value="undtaget">Ingen undervisningsopgaver (ikke indberet)</option>
          </select>
        </td>
        <td>
          <input type="text"
                 style="width: 110px"
                 :value="user.v_ssn"
                 @keydown.enter="updateUser(user, 'ssn', $event.target.value, true)"
                 @blur="updateUser(user, 'ssn', $event.target.value)">
        </td>
        <td>
          <div style="width: 400px" @click="theEditUserId = user.id">
            <DSelect
              v-if="user.v_isTheEditUser"
              :show="true"
              :items="standardSubjectsWithVProps"
              :itemsSelected="user.v_competencies"
              placeholder="Tilføj kompetence"
              @close="theEditUserId = null"
              @update="updateSubjectOnUser($event, user)">
            </DSelect>
            <ul class="linjefag linjefag--not-empty" style="width: 400px;" v-else>
              <li class="linjefag__add" v-if="user.v_competencies.length === 0">
                Tilføj op til seks kompetencer
              </li>
              <li class="d-pill" v-for="subject in user.v_competencies">
                {{ subject.name }}
              </li>
            </ul>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway'
import docendo from '../../../docendo'
import eventbus from '../../../eventbus'
import StilGuides from './../StilGuides'
import DSelect from './KompetenceIndberetningDSelect'

export default {
  components: {DSelect, StilGuides},
  mixins: [clickaway],
  props: {
    standardSubjects: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      theSelectMonth: null,
      activeUserFilter: 0,
      standardSubjectsWithVProps: [],
      levelMap: {
        L: 'Linjefag',
        K: 'Tilsvarende kompetencer'
      },
      theEditUserId: null,
      sortProperty: 'name', // default property to sort on
      sortOrder: 'asc' // default sort order
    }
  },
  computed: {
    schoolId () {
      return this.$route.params.school_id
    },
    users () {
      return this.$store.getters.usersSortedOnName
    },
    usersWithVProps () {
      return this.users.map(user => {
        const competencies = []
        if (!user.competencies) {
          console.log('user', user, user.competencies)
        }
        user.competencies.forEach(subject => {
          const id = subject.subject_code + '_' + subject.level
          const idx = this.standardSubjectsWithVProps.findIndex(subjectWithVProps => subjectWithVProps.id === id)
          const obj = {
            id: subject.subject_code + '_' + subject.level,
            subject_code: subject.subject_code,
            level: subject.level,
            name: this.standardSubjectsWithVProps[idx].name
          }
          competencies.push(obj)
        })
        const vSsn = user.ssn && user.ssn.length > 6 ? user.ssn : ''
        const isTheEditUser = this.theEditUserId === user.id
        let stilStilling = null
        if (user.custom_data && user.custom_data['schools'] && user.custom_data['schools'][this.schoolId] && user.custom_data['schools'][this.schoolId]['stilling']) {
          stilStilling = user.custom_data['schools'][this.schoolId]['stilling']
        }
        this.$set(user, 'v_stil_stilling', stilStilling)
        this.$set(user, 'v_ssn', vSsn)
        this.$set(user, 'v_competencies', competencies)
        this.$set(user, 'v_isTheEditUser', isTheEditUser)
        return user
      })
    },
    unfilledUsers () {
      return this.usersWithVProps.filter(user => user.v_stil_stilling === 'undtaget')
    },
    filledUsers () {
      return this.usersWithVProps.filter(user => user.v_stil_stilling !== 'undtaget')
    },
    filteredUsersWithVProps () {
      if (this.activeUserFilter === 0) {
        return this.filledUsers
      } else {
        return this.unfilledUsers
      }
    },
    sortedUsers () {
      const arrCopy = [...this.filteredUsersWithVProps]
      const sortOrder = this.sortOrder === 'asc' ? 1 : -1
      return arrCopy.sort((a, b) => {
        const propA = a[this.sortProperty]
        const propB = b[this.sortProperty]
        if (propA === null || propA === undefined) {
          return 1 * sortOrder
        }
        if (propB === null || propB === undefined) {
          return -1 * sortOrder
        }
        const propAUppercase = propA.toUpperCase()
        const propBUppercase = propB.toUpperCase()
        if (propAUppercase < propBUppercase) {
          return -1 * sortOrder
        }
        if (propAUppercase > propBUppercase) {
          return 1 * sortOrder
        }
        return 0
      }).concat(arrCopy.filter(item => item[this.sortProperty] === null || item[this.sortProperty] === undefined))
    }
  },
  methods: {
    setSortProperty (property) {
      if (this.sortProperty === property) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortOrder = 'asc'
      }
      this.sortProperty = property
    },
    validateCPR (vSsn) {
      const ssn = vSsn.replace(/[^0-9]/ig, '')
      return ssn.length === 10
    },
    updateSubjectOnUser (subjects, user) {
      const subjectForServer = []
      subjects.forEach(subject => {
        const obj = {
          subject_code: subject.subject_code,
          level: subject.level
        }
        subjectForServer.push(obj)
      })
      docendo.updateUserCompetencies(this.schoolId, user.id, subjectForServer, success => {
        const userCompetencies = success.filter(subject => subject.user_id === user.id)
        const data = {
          prop: 'competencies',
          userId: user.id,
          competencies: userCompetencies
        }
        eventbus.toast = {text: 'Linjefag er opdateret', success: true}
        this.$store.commit('updatePropOnSchoolUser', data)
      }, failure => {
        console.log('failed')
      })
    },
    updateUser (user, change, val, forceUpdate) {
      let customData = user.custom_data
      let errors = false
      let changes = {}
      changes[change] = val
      if (change === 'stil_stilling') {
        if (!customData['schools']) {
          customData.schools = {[this.schoolId]: {'stilling': val}}
        }
        if (customData['schools'] && !customData['schools'][this.schoolId]) {
          customData['schools'][this.schoolId] = {'stilling': val}
        }
        if (customData['schools'] && customData['schools'][this.schoolId]) {
          customData['schools'][this.schoolId]['stilling'] = val
        }
        changes['custom_data'] = customData
      }
      if (change === 'ssn') {
        val = val.replace(/[^0-9]/ig, '')
        if (!forceUpdate && (val === user.ssn || val.length === 0)) {
          const originalSSN = JSON.parse(JSON.stringify(user.ssn))
          user.ssn = null
          user.ssn = originalSSN
          return
        }
        if (!this.validateCPR(val)) {
          eventbus.toast = {text: 'Ugyldigt cpr nummer', success: false}
          errors = true
          const originalSSN = JSON.parse(JSON.stringify(user.ssn))
          user.ssn = null
          user.ssn = originalSSN
        }
        changes[change] = val
      }
      if (errors) {
        return
      }
      docendo.updateUsers(this.schoolId, user.id, changes, success => {
        for (let key of Object.keys(changes)) {
          const data = {
            prop: key,
            userId: user.id,
            [key]: success[key]
          }
          this.$store.commit('updatePropOnSchoolUser', data)
        }
        if (change === 'ssn') {
          this.updateStilReportUser(user)
        } else {
          eventbus.toast = {text: 'Opdateret', success: true}
        }
      }, failure => {
        if (change === 'ssn') {
          const originalSSN = JSON.parse(JSON.stringify(user.ssn))
          user.ssn = null
          user.ssn = originalSSN
          eventbus.toast = {text: 'CPR er allerede brugt', success: false}
        }
      })
    },
    updateStilReportUser (user) {
      this.$emit('updateStilReportUser', user)
    },
    createStandardSubjectsWithVProps () {
      const sortedSubjects = this.standardSubjects.sort((a, b) => {
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
      })
      sortedSubjects.forEach(subject => {
        for (let key of Object.keys(this.levelMap)) {
          let obj = {}
          obj.level = key
          obj.name = subject.name + ' (' + key + ')'
          obj.id = subject.subject_code + '_' + key
          obj.user_id = subject.subject_code + '_' + key
          obj.subject_code = subject.subject_code
          this.standardSubjectsWithVProps.push(obj)
        }
      })
    }
  },
  beforeMount () {
    this.createStandardSubjectsWithVProps()
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-table__name {
  width: 250px;
}

.uppercase {
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

.d-timetal__container {
  padding: 2rem 1rem;
  border: 1px solid #d8d8d8;
  width: 100%;
  max-width: 1440px;
  min-width: 1100px;
  border-radius: 4px;
}

.d-table {
  width: 100%;
  border: 1px solid #d8d8d8;
  border-collapse: collapse;
  border-radius: 4px;
}

.d-table thead {
  border-bottom: 1px solid #d8d8d8;
  background: #f6f9fc;
  color: #728195;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
}

.d-table thead th {
  padding: 0.5rem 1rem;
  text-align: left;
}

.d-table tbody tr {
  width: 100%;
  background: #f9fafb;
  border-bottom: 1px solid #e3e8ee;
}

.d-table tbody tr:nth-child(odd) {
  background: #ffffff;
}

.d-table tbody tr td:first-child {
  width: 100% !important;
}

.d-table tbody tr:hover {
  background: aliceblue;
}

.d-table tbody tr td {
  padding: 0.5rem 1rem;
  text-align: left;
  width: 75px !important;
}

.birthday {
  display: inline-flex;
  border: 1px solid #acb6be;
  border-radius: 4px;
}

.birthday input[type="text"] {
  border: none;
  border-radius: 4px 0 0 4px;
  border-right: 1px dashed #888888;
  text-align: center;
  width: 60px;
}

.birthday input[type="text"]:focus {
  border-color: var(--blue);
}

.birthday div:last-child input[type="text"] {
  margin-right: 0;
  border-right: 0 !important;
  width: 60px;
  border-radius: 0 4px 4px 0;
}

.d-number {
  text-align: right;
}

select.timetal-select,
input[type="date"] {
  height: 36px;
  background-color: #ffffff;
  border-radius: 4px;
  min-width: 100px;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);
  border: 1px solid #d8d8d8;
}

input[type="date"] {
  padding: 9px;
  width: 150px;
}

.d-filters {
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
}

.d-filters__filter {
  padding: 0.5rem 1.5rem;
  border: 1px solid #d8d8d8;
  border-width: 1px 1px 0 1px;
  margin-right: 1rem;
  border-radius: 4px 4px 0 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: bold;
}

.d-filters__filter.d-filters__filter--active {
  background: #f6f9fc;
  color: var(--primary)
}

.d-filters__filter.d-filters__filter--active > .d-pill {
  background: #e0e7ff;
  color: var(--primary);
  border-color: transparent;
}

.d-filters__filter > .d-pill {
  margin-left: 1rem;
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  color: #111827;
  padding: 4px 8px;
  font-weight: bold;
  background: transparent;
  border: 1px solid rgba(204, 204, 204, 0.75);
  font-size: 11px;
}

.d-guides {
  border: 1px solid rgba(204, 204, 204, 0.75);
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.linjefag {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  flex-wrap: wrap;
  padding: 0.25rem 0.5rem;
  border: 1px dashed #ccc;
  border-radius: 4px;
  transition: all 0.25s;
}

.linjefag:hover {
  background: #ffffff;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
}

.linjefag__add {
  cursor: pointer;
  border-radius: 4px;
  color: #888888;
  width: 100%;
}


.d-pill {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  font-size: 1rem;
  color: #222222;
  display: inline-block;
  border-radius: 4px;
  padding: 4px 8px;
  line-height: 1rem;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}

.text-explainer p {
  margin-bottom: 0.5rem;
}

.d-table__sorter {
  cursor: pointer;
  transition: transform 0.25s;
}

.d-table__sorter:active {
  transform: scale(0.985);
}

.d-table__sorter--active {
  color: var(--purple);
}


</style>



// WEBPACK FOOTER //
// KompetenceIndberetningLinjeFag.vue?67977a13